import { memo } from 'react';
import type { SceneState } from '@/api/types';
import { affectedCells, areaPolygon } from './geometry';
import { KIND_RING, SIZE_CELLS } from './model';

/** Miniatura de una escena para las tarjetas y el historial: solo formas, sin texto. */
export const ScenePreview = memo(function ScenePreview({
  state,
  className,
}: {
  state: SceneState;
  className?: string;
}) {
  const { cols, rows } = state.grid;
  return (
    <svg
      viewBox={`-0.5 -0.5 ${cols + 1} ${rows + 1}`}
      preserveAspectRatio="xMidYMid meet"
      className={className}
      aria-hidden
    >
      <rect x={0} y={0} width={cols} height={rows} fill="var(--c-mat)" rx={0.3} />
      {state.map && (
        <image
          href={`/api/maps/${state.map.id}/thumb`}
          x={0}
          y={0}
          width={cols}
          height={rows}
          preserveAspectRatio="none"
          opacity={state.map.opacity}
        />
      )}
      {state.areas.map((a) =>
        state.display.showAffectedCells ? (
          <g key={a.id} fill={a.color} fillOpacity={a.opacity}>
            {affectedCells(a, cols, rows).map(([i, j]) => (
              <rect key={`${i}:${j}`} x={i} y={j} width={1} height={1} />
            ))}
          </g>
        ) : a.shape === 'circle' ? (
          <circle key={a.id} cx={a.x} cy={a.y} r={a.size} fill={a.color} fillOpacity={a.opacity} />
        ) : a.shape === 'square' ? (
          <rect key={a.id} x={a.x} y={a.y} width={a.size} height={a.size} fill={a.color} fillOpacity={a.opacity} />
        ) : (
          <polygon
            key={a.id}
            points={areaPolygon(a)
              .map((p) => `${p.x},${p.y}`)
              .join(' ')}
            fill={a.color}
            fillOpacity={a.opacity}
          />
        ),
      )}
      <path
        d={
          Array.from({ length: Math.floor(cols / 5) + 1 }, (_, k) => `M${k * 5} 0V${rows}`).join('') +
          Array.from({ length: Math.floor(rows / 5) + 1 }, (_, k) => `M0 ${k * 5}H${cols}`).join('')
        }
        stroke="var(--c-grid)"
        strokeOpacity={0.35}
        strokeWidth={0.12}
        fill="none"
      />
      {state.tokens.map((t) => {
        const s = SIZE_CELLS[t.size];
        return (
          <circle
            key={t.id}
            cx={t.x + s / 2}
            cy={t.y + s / 2}
            r={s / 2 - 0.12}
            fill={t.color}
            stroke={KIND_RING[t.kind]}
            strokeWidth={0.18}
          />
        );
      })}
    </svg>
  );
});
